<div class="min-h-screen bg-white">
  <!-- Breadcrumb -->
  <div class="w-full px-4 sm:px-6 lg:px-8 pt-1.5 pb-1 sm:py-3">
    <app-breadcrum [data]="breadcrumbs"></app-breadcrum>
  </div>

  <div class="w-full mx-auto px-4 sm:px-6 lg:px-8 flex items-start gap-8 max-md:flex-col max-md:gap-4 mt-0.5 sm:mt-2">
    <!-- Main Content -->
    <div
      class="left-content flex-1 min-w-0 space-y-8 max-md:space-y-4 md:overflow-y-auto md:max-h-[calc(100vh-130px)] pb-6">
      <!-- Order Header -->
      <div class="bg-white border border-input-field-stroke rounded-lg p-4 space-y-2 max-md:p-3.5 max-md:space-y-3">
        <div class="flex justify-between items-center max-md:grid max-md:grid-cols-2 max-md:gap-x-4 max-md:gap-y-3">
          <!-- Invoice no -->
          <div class="space-y-1 max-md:p-0"
            *ngIf="orderDetail?.invoice_status !== 'Payment Failed' && orderDetail?.invoice_status !== 'Payment Pending' && orderDetail?.invoice_status !== 'aborted'">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              {{document_type}} no
            </div>
            <div class="text-text-caption text-base font-bold max-md:text-sm max-md:text-[12px] max-md:leading-[16px]">
              {{ orderDetail?.invoiceNo }}
            </div>
          </div>

          <div class="space-y-1 max-md:p-0"
            *ngIf="orderDetail?.invoice_status === 'Payment Failed' || orderDetail?.invoice_status === 'aborted'">
            <div
              class="flex items-center gap-2 text-[#E30613] text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              <span>Payment Failed</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20">
                <defs>
                  <linearGradient id="errorGradient" x1="16" x2="16" y1="2.888" y2="29.012"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#ff624a" />
                    <stop offset=".25" stop-color="#ff5940" />
                    <stop offset=".67" stop-color="#fd4224" />
                    <stop offset="1" stop-color="#fc2c0a" />
                  </linearGradient>
                </defs>

                <!-- Circle background -->
                <circle cx="16" cy="16" r="13" fill="url(#errorGradient)" />

                <!-- White "X" -->
                <path fill="#fff" d="M17.414,16l3.288-3.288c0.391-0.391,0.391-1.024,0-1.414
                   c-0.391-0.391-1.024-0.391-1.414,0L16,14.586l-3.288-3.288
                   c-0.391-0.391-1.024-0.391-1.414,0c-0.391,0.391-0.391,1.024,0,1.414
                   L14.586,16l-3.288,3.288c-0.391,0.391-0.391,1.024,0,1.414
                   c0.391,0.391,1.024,0.391,1.414,0L16,17.414l3.288,3.288
                   c0.391,0.391,1.024,0.391,1.414,0c0.391-0.391,0.391-1.024,0-1.414
                   L17.414,16z" />
              </svg>
            </div>

            <div class="text-text-caption text-base font-bold max-md:text-sm max-md:text-[12px] max-md:leading-[16px]">
              Server Issue of your Bank
            </div>
          </div>
          <div class="space-y-1 max-md:p-0" *ngIf="orderDetail?.invoice_status === 'Payment Pending'">
            <div
              class="flex items-center gap-2 text-[#EB8700] text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              <span>Payment Pending</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20">
                <defs>
                  <linearGradient id="pendingExclamationGradient" x1="16" x2="16" y1="2" y2="30"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#FFD234" />
                    <stop offset="1" stop-color="#FFA500" />
                  </linearGradient>
                </defs>

                <!-- Circle background -->
                <circle cx="16" cy="16" r="13" fill="url(#pendingExclamationGradient)" />

                <!-- Exclamation mark -->
                <rect x="15" y="8" width="2" height="12" fill="white" rx="1" />
                <circle cx="16" cy="23" r="2" fill="white" />
              </svg>
            </div>

            <div class="text-text-caption text-base font-bold max-md:text-sm max-md:text-[12px] max-md:leading-[16px]">
              {{ orderDetail?.isBooking ? 'Complete the payment to confirm your booking' : 'Server Issue of your Bank'
              }}
            </div>
          </div>

          <div class="space-y-1 max-md:p-0" [class.max-md:justify-self-end]="orderDetail?.isBooking"
            [class.max-md:text-right]="orderDetail?.isBooking"
            *ngIf="(orderDetail?.invoice_status === 'Payment Failed' || orderDetail?.invoice_status === 'Payment Pending' || orderDetail?.invoice_status === 'aborted') && !orderDetail?.isBooking">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              Home Delivery
            </div>
            <div class="text-text-caption text-base font-bold max-md:text-sm">
              Estimated after order
            </div>
          </div>
          <div class="space-y-1 max-md:p-0" [class.max-md:justify-self-end]="orderDetail?.isBooking"
            [class.max-md:text-right]="orderDetail?.isBooking"
            *ngIf="(orderDetail?.invoice_status === 'Payment Failed' || orderDetail?.invoice_status === 'Payment Pending'|| orderDetail?.invoice_status === 'aborted') && !orderDetail?.isBooking">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              Order Rating
            </div>
            <div class="text-text-caption text-base font-bold max-md:text-sm">
              Post-Delivery
            </div>
          </div>

          <!-- Order no (also shown for bookings while payment is pending) -->
          <div class="space-y-1 max-md:p-0 max-md:justify-self-end max-md:text-right">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              Order no
            </div>
            <div class="text-text-caption text-base font-bold max-md:text-sm">
              {{ orderDetail?.orderNo }}
            </div>
          </div>

          <!-- Booking Date -->
          <div class="space-y-1 max-md:p-0" *ngIf="orderDetail?.isBooking">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              {{ document_type === 'Enquiry' ? 'Enquiry Date' : 'Booking Date' }}</div>
            <div class="text-text-caption text-base font-bold max-md:text-sm">{{ orderDetail?.bookingDate | date : 'dd
              MMM yyyy' }}</div>
          </div>

          <!-- Estimated Delivery -->
          <div class="space-y-1 max-md:p-0" [class.max-md:justify-self-end]="orderDetail?.isBooking"
            [class.max-md:text-right]="orderDetail?.isBooking"
            *ngIf="orderDetail?.invoice_status !== 'Payment Failed' && orderDetail?.invoice_status !== 'Payment Pending' && orderDetail?.invoice_status !== 'Order Cancelled' && orderDetail?.invoice_status !== 'aborted' && orderDetail?.invoice_status !== 'Return Requested' && orderDetail?.invoice_status !== 'Refund Credited' && orderDetail?.invoice_status !== 'Picked Up' && orderDetail?.invoice_status !== 'Delivered'">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              {{deleveryType ? "Pick up By" : "Estimated Delivery" }}
            </div>
            <div class="text-text-caption text-base font-bold max-md:text-sm">
              {{ (orderDetail?.estimatedDelivery || futureTwoDaysDate) | date : "dd MMM yyyy" }}
            </div>
          </div>

          <div class="space-y-1 max-md:p-0" [class.max-md:justify-self-end]="orderDetail?.isBooking"
            [class.max-md:text-right]="orderDetail?.isBooking"
            *ngIf="orderDetail?.invoice_status === 'Picked Up' || orderDetail?.invoice_status === 'Delivered'">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              {{ deleveryType ? "Pickup On" : "Delivery Date" }}
            </div>
            <div class="text-text-caption text-base font-bold max-md:text-sm">
              {{ orderDetail?.estimatedDelivery | date : "dd MMM yyyy" }}
            </div>
          </div>
          <div class="space-y-1 max-md:p-0" [class.max-md:justify-self-end]="orderDetail?.isBooking"
            [class.max-md:text-right]="orderDetail?.isBooking"
            *ngIf="orderDetail?.invoice_status === 'Return Requested'">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              Return Requested
            </div>
            <div class="text-text-caption text-base font-bold max-md:text-sm">
              {{ orderDetail?.estimatedDelivery | date : "dd MMM yyyy" }}
            </div>
          </div>
          <div class="space-y-1 max-md:p-0" [class.max-md:justify-self-end]="orderDetail?.isBooking"
            [class.max-md:text-right]="orderDetail?.isBooking"
            *ngIf="orderDetail?.invoice_status === 'Order Cancelled'">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              Order Cancelled
            </div>
            <div class="text-text-caption text-base font-bold max-md:text-sm">
              {{ orderDetail?.estimatedDelivery | date : "dd MMM yyyy" }}
            </div>

          </div>
          <div class="space-y-1 max-md:p-0" [class.max-md:justify-self-end]="orderDetail?.isBooking"
            [class.max-md:text-right]="orderDetail?.isBooking"
            *ngIf="(orderDetail?.invoice_status === 'Delivered' || orderDetail?.invoice_status === 'Picked Up') && orderDetail?.invoiceRating > 0">
            <div
              class="text-primary-deep-blue text-[16px] font-bold whitespace-nowrap max-md:text-[12px] max-md:leading-[16px]">
              Rating
            </div>
            <div class="text-text-caption text-base font-bold max-md:text-sm">
              <span *ngIf="orderDetail?.invoiceRating === 1" class="flex items-center gap-1">
                <span class="text-primary-deep-blue">
                  <svg width="24" height="24" viewBox="0 0 46.6667 46.6667" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M46.6667 23.3333C46.6667 36.22 36.22 46.6667 23.3333 46.6667C10.4467 46.6667 0 36.22 0 23.3333C0 10.4467 10.4467 0 23.3333 0C36.22 0 46.6667 10.4467 46.6667 23.3333Z"
                      fill="#EE1520" />
                    <path
                      d="M30.334 32.6666C30.334 32.6666 28.0007 30.3332 23.334 30.3332C18.6673 30.3332 16.334 32.6666 16.334 32.6666M11.6445 23.0725C13.5705 23.9175 17.0174 23.3098 18.5382 21.8569M28.1298 21.8568C29.6506 23.3096 33.0974 23.9174 35.0234 23.0723"
                      stroke="black" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </span>
                | Poor
              </span>

              <span *ngIf="orderDetail?.invoiceRating === 2" class="flex items-center gap-1">
                <span class="text-primary-deep-blue">

                  <svg width="24" height="24" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M51.3327 28C51.3327 40.8866 40.886 51.3333 27.9993 51.3333C15.1127 51.3333 4.66602 40.8866 4.66602 28C4.66602 15.1133 15.1127 4.66663 27.9993 4.66663C40.886 4.66663 51.3327 15.1133 51.3327 28Z"
                      fill="#FFD234" />
                    <path
                      d="M20.2217 22.1667C21.5102 22.1667 22.5555 23.2112 22.5557 24.4998C22.5557 25.7884 21.5103 26.8337 20.2217 26.8337C18.9332 26.8336 17.8887 25.7883 17.8887 24.4998C17.8888 23.2113 18.9333 22.1669 20.2217 22.1667ZM35.7773 22.1667C37.0659 22.1667 38.1112 23.2112 38.1113 24.4998C38.1113 25.7884 37.066 26.8337 35.7773 26.8337C34.4888 26.8336 33.4443 25.7883 33.4443 24.4998C33.4445 23.2113 34.4889 22.1669 35.7773 22.1667Z"
                      fill="black" />
                    <path d="M35 37.3335H21" stroke="black" stroke-width="2.33333" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>

                </span>
                | Good
              </span>
              <span *ngIf="orderDetail?.invoiceRating === 3" class="flex items-center gap-1">
                <span class="text-primary-deep-blue">

                  <svg width="24" height="24" viewBox="0 0 46.6667 46.6667" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M46.6667 23.3333C46.6667 36.22 36.22 46.6667 23.3333 46.6667C10.4467 46.6667 0 36.22 0 23.3333C0 10.4467 10.4467 0 23.3333 0C36.22 0 46.6667 10.4467 46.6667 23.3333Z"
                      fill="#36B548" />
                    <path
                      d="M11.6656 18.6666C12.8322 12.8333 17.4989 12.8333 18.6656 18.6666M27.9989 18.6666C29.1656 12.8333 33.8322 12.8333 34.9989 18.6666M23.3323 37.3333C17.2366 37.3333 12.0508 33.4375 10.1289 28C10.1289 28 18.6656 29.1666 23.3323 29.1666C27.9989 29.1666 36.5357 28 36.5357 28C34.6137 33.4375 29.428 37.3333 23.3323 37.3333Z"
                      stroke="black" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </span>
                | Excellent
              </span>
            </div>

          </div>
          <!--     
      <button
        *ngIf="isBookingFlow"
        (click)="onViewBookingClick()"
        class="px-5 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors max-md:col-span-2 max-md:w-full max-md:py-2.5 max-md:text-center max-md:mt-1"
      >
        Pay Now
      </button> -->

          <!-- Cancel button -->
          <button
            *ngIf="document_type !== 'Enquiry' && orderDetail?.invoice_status !== 'Payment Failed' && orderDetail?.invoice_status !== 'Payment Pending' && orderDetail?.invoice_status !== 'Order Cancelled' && orderDetail?.invoice_status !== 'Delivered' && orderDetail?.invoice_status !== 'aborted' && orderDetail?.invoice_status !== 'Return Requested' && orderDetail?.invoice_status !== 'Refund Credited' && orderDetail?.invoice_status !== 'Picked Up' && orderDetail?.invoice_status !== 'Out for Delivery' && orderDetail?.invoice_status !== 'Order Ready' && orderDetail?.invoice_status !== 'In-Transit' && orderDetail?.invoice_status !== 'Payment Successful'"
            (click)="openCancelPopup()"
            class="px-5 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors max-md:col-span-2 max-md:w-full max-md:py-2.5 max-md:text-center max-md:mt-1">
            Cancel
          </button>

          <button
            *ngIf="orderDetail?.invoice_status === 'Payment Failed' || orderDetail?.invoice_status === 'Payment Pending' || orderDetail?.invoice_status === 'aborted'"
            (click)="initiatePayment(orderDetail)" [disabled]="!retryPaymentMethod(orderDetail)"
            class="px-5 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed max-md:col-span-2 max-md:w-full max-md:py-2.5 max-md:text-center max-md:mt-1">
            Retry Payment
          </button>

          <!-- Rate button -->
          <button
            *ngIf="(orderDetail?.invoice_status === 'Delivered' || orderDetail?.invoice_status === 'Picked Up') && orderDetail?.invoiceRating === 0"
            (click)="toggleRatingPopup()"
            class="px-4 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold transition-colors inline-flex items-center justify-center gap-2 max-md:col-span-2 max-md:w-full max-md:py-2.5 max-md:mt-1">
            <!-- (click)="toggleRatingPopup()"   hover:bg-primary-deep-blue hover:text-white -->
            <!-- Star Icon -->
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_7704_20232)">
                <path
                  d="M10.501 0.916992C15.5173 0.917168 19.5848 4.98367 19.585 10C19.5848 15.0163 15.5173 19.0838 10.501 19.084C5.48465 19.0838 1.41814 15.0163 1.41797 10C1.41814 4.98367 5.48465 0.917168 10.501 0.916992ZM10.501 2.41699C6.31308 2.41717 2.91814 5.8121 2.91797 10C2.91814 14.1879 6.31308 17.5838 10.501 17.584C14.6889 17.5838 18.0848 14.1879 18.085 10C18.0848 5.8121 14.6889 2.41717 10.501 2.41699ZM15.1143 10.9238C15.3734 10.8884 15.6327 10.9906 15.7979 11.1934C15.9629 11.3961 16.01 11.6705 15.9229 11.917C15.1337 14.1489 13.0054 15.7499 10.501 15.75C7.99647 15.7499 5.86716 14.149 5.07812 11.917C4.99105 11.6706 5.03836 11.3961 5.20312 11.1934C5.36821 10.9906 5.6277 10.8885 5.88672 10.9238H5.88867C5.88993 10.924 5.89206 10.9245 5.89453 10.9248C5.90001 10.9255 5.909 10.9272 5.91992 10.9287C5.94198 10.9317 5.97534 10.9359 6.01758 10.9414C6.10277 10.9526 6.22697 10.969 6.38086 10.9883C6.68939 11.0269 7.1181 11.0784 7.59766 11.1299C8.56717 11.2339 9.71159 11.334 10.501 11.334C11.2902 11.334 12.4339 11.2339 13.4033 11.1299C13.8827 11.0784 14.3115 11.0269 14.6201 10.9883C14.7741 10.969 14.8991 10.9526 14.9844 10.9414C15.0266 10.9358 15.06 10.9317 15.082 10.9287C15.0926 10.9273 15.101 10.9256 15.1064 10.9248C15.109 10.9245 15.1119 10.924 15.1133 10.9238H15.1143ZM13.5635 12.6211C12.5922 12.7253 11.3781 12.834 10.501 12.834C9.62373 12.834 8.40881 12.7253 7.4375 12.6211C7.33129 12.6097 7.22749 12.5962 7.12695 12.585C7.90408 13.5976 9.12707 14.2499 10.501 14.25C11.8745 14.2499 13.0959 13.5971 13.873 12.585C13.7728 12.5962 13.6693 12.6097 13.5635 12.6211ZM7.58398 6.66699C8.27434 6.66699 8.83398 7.22664 8.83398 7.91699C8.83381 8.6072 8.27423 9.16699 7.58398 9.16699C6.89389 9.16682 6.33416 8.60709 6.33398 7.91699C6.33398 7.22674 6.89378 6.66717 7.58398 6.66699ZM13.418 6.66699C14.1082 6.66717 14.668 7.22674 14.668 7.91699C14.6678 8.60709 14.1081 9.16682 13.418 9.16699C12.7277 9.16699 12.1681 8.6072 12.168 7.91699C12.168 7.22664 12.7276 6.66699 13.418 6.66699Z"
                  fill="#0A0A5F" />
              </g>
              <defs>
                <clipPath id="clip0_7704_20232">
                  <rect width="20" height="20" fill="white" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </svg>

            Rate
          </button>
        </div>

        <div
          *ngIf="(orderDetail?.invoice_status !== 'Order Cancelled' && orderDetail?.invoice_status !== 'In-Transit' && orderDetail?.invoice_status !== 'Out for Delivery' && orderDetail?.invoice_status !== 'Order Ready' && orderDetail?.invoice_status !== 'Picked Up'&& orderDetail?.invoice_status !== 'Delivered' && orderDetail?.invoice_status !== 'Return Requested' && orderDetail?.invoice_status !== 'Refund Credited' ) || orderDetail?.invoice_status == 'Payment Failed' || orderDetail?.invoice_status == 'Payment Pending' || orderDetail?.invoice_status == 'aborted'"
          class="mt-2.5 bg-neutrals-off-white p-2.5 rounded-lg flex items-center gap-2 max-md:gap-2.5">
          <svg class="w-4 h-4 text-primary-deep-blue max-md:w-5 max-md:h-5" fill="none" stroke="currentColor"
            viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <div class="text-primary-deep-blue text-sm font-bold max-md:text-[12px] max-md:leading-[16px]"
            *ngIf="orderDetail?.invoice_status !== 'Order Cancelled' && orderDetail?.invoice_status !== 'Payment Failed' && orderDetail?.invoice_status !== 'Payment Pending' && orderDetail?.invoice_status !== 'aborted' && orderDetail?.invoice_status !== 'Order Ready' && orderDetail?.invoice_status !== 'Picked Up'&& orderDetail?.invoice_status !== 'Delivered' && orderDetail?.invoice_status !== 'Return Requested' && orderDetail?.invoice_status !== 'Refund Credited' && orderDetail?.invoice_status !== 'Payment Successful' && orderDetail?.invoice_status !== 'In-Transit' && orderDetail?.invoice_status !== 'Out for Delivery'">
            Cancellation is possible before shipping only
          </div>

          <div class="text-primary-deep-blue text-sm font-bold max-md:text-[12px] max-md:leading-[16px]"
            *ngIf="orderDetail?.invoice_status === 'Payment Failed' || orderDetail?.invoice_status === 'aborted'">
            To proceed with reorder, kindly “Retry payment” for all available items
          </div>

          <div class="text-primary-deep-blue text-sm font-bold max-md:text-[12px] max-md:leading-[16px]"
            *ngIf="orderDetail?.invoice_status === 'Payment Pending' && !orderDetail?.isBooking">
            To order again, please retry Payment
          </div>
          <div class="text-primary-deep-blue text-sm font-bold max-md:text-[12px] max-md:leading-[16px]"
            *ngIf="orderDetail?.invoice_status === 'Payment Pending' && orderDetail?.isBooking">
            Complete the payment below to confirm your booking
          </div>
        </div>
      </div>

      <div *ngIf="pendingPaymentInvoices?.length" class="space-y-3">
        <div *ngFor="let invoice of pendingPaymentInvoices"
          class="border border-input-field-stroke rounded-xl bg-white overflow-hidden">
          <div class="px-4 py-3 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div class="flex items-start gap-3 min-w-0">
              <div
                class="w-9 h-9 rounded-full bg-[#FFF4E5] border border-[#FFD8A8] flex items-center justify-center shrink-0">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10" cy="10" r="10" fill="#F08A00" />
                  <rect x="9" y="4.5" width="2" height="8" rx="1" fill="white" />
                  <circle cx="10" cy="14.5" r="1.1" fill="white" />
                </svg>
              </div>
              <div class="min-w-0">
                <div class="text-[#E77D00] text-base font-bold leading-6 max-md:text-sm">
                  Payment Pending
                </div>
                <div class="text-text-caption text-xs font-medium md:text-sm">
                  Please complete the payment to confirm your order.
                </div>
              </div>
            </div>

            <div class="flex items-center gap-3 md:gap-6 flex-wrap md:flex-nowrap max-md:w-full max-md:justify-between">
              <div class="min-w-[150px] max-md:min-w-0 max-md:w-[48%]">
                <div class="text-text-caption text-xs font-medium md:text-sm"> {{document_type}} No</div>
                <div class="text-text-caption text-sm font-bold md:text-base">
                  {{ invoice?.booking_number }}
                </div>
              </div>
              <div class="min-w-[90px] max-md:min-w-0 max-md:w-[20%]">
                <div class="text-text-caption text-xs font-medium md:text-sm">Items</div>
                <div class="text-text-caption text-sm font-bold md:text-base">
                  {{ getPendingPaymentItemsLabel(invoice) }}
                </div>
              </div>
              <div class="min-w-[100px] max-md:min-w-0 max-md:w-[25%]">
                <div class="text-text-caption text-xs font-medium md:text-sm">Amount</div>
                <div class="text-text-caption text-sm font-bold md:text-base">
                  {{ formatPrice(invoice?.payment_amount || 0) }}
                </div>
              </div>
              <button (click)="payInvoice(invoice)"
                class="h-10 px-6 rounded-lg bg-primary-deep-blue text-white text-sm font-bold hover:opacity-95 transition-opacity max-md:h-9 max-md:px-4">
                Pay Now
              </button>
              <button (click)="togglePendingPaymentCard(invoice)"
                class="w-10 h-10 rounded-lg border border-input-field-stroke flex items-center justify-center text-primary-deep-blue max-md:w-9 max-md:h-9"
                aria-label="Toggle payment details">
                <svg class="w-5 h-5 transition-transform" [class.rotate-180]="isPendingPaymentCardExpanded(invoice)"
                  viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </button>
            </div>
          </div>

          <div class="px-4 pb-4" *ngIf="isPendingPaymentCardExpanded(invoice)">
            <div class="border border-input-field-stroke rounded-lg p-3 bg-neutrals-off-white">
              <div class="text-primary-deep-blue text-lg font-bold mb-3 max-md:text-base">Product Details</div>
              <div *ngFor="let part of invoice?.part_details"
                class="border border-input-field-stroke rounded-lg p-3 bg-white mb-3 last:mb-0">
                <div class="flex items-start gap-3">
                  <div class="w-16 h-16 rounded-lg bg-[#F5F9FF] flex items-center justify-center shrink-0">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 3L19 7V17L12 21L5 17V7L12 3Z" stroke="#307FE1" stroke-width="1.8"
                        stroke-linejoin="round" />
                      <path d="M12 3V21M5 7L12 11L19 7" stroke="#307FE1" stroke-width="1.5" stroke-linejoin="round" />
                    </svg>
                  </div>
                  <div class="min-w-0 w-full">
                    <div class="text-black text-base font-bold max-md:text-sm">
                      {{ part?.part_name }}
                    </div>
                    <div class="mt-2 flex gap-8 max-md:gap-5">
                      <div>
                        <div class="text-text-caption text-xs font-medium md:text-sm">Category</div>
                        <div class="text-text-caption text-sm font-bold md:text-base">{{ part?.category }}</div>
                      </div>
                      <div>
                        <div class="text-text-caption text-xs font-medium md:text-sm">Sub Category</div>
                        <div class="text-text-caption text-sm font-bold md:text-base">{{ part?.sub_category }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3 pt-3 border-t border-input-field-stroke flex items-center justify-between">
                <div class="text-text-caption text-sm font-medium">Payment Amount</div>
                <div class="text-primary-deep-blue text-2xl font-bold leading-8 max-md:text-xl">
                  {{ formatPrice(invoice?.payment_amount || 0) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Order Status - Dynamic from API Response -->
      @if(orderDetail?.status && orderDetail.status.length > 0 && orderDetail?.invoice_status !== 'Payment Failed' &&
      orderDetail?.invoice_status !== 'aborted' && !isEnquiry()){
      <div class="space-y-6 max-md:space-y-4">
        <!-- Desktop Order Status -->
        <div class="hidden md:block">
          <div class="flex justify-between items-center">
            <div class="text-primary-deep-blue text-xl font-bold">
              Order status
            </div>
            <div class="flex items-center gap-4">
              <button (click)="toggleOrderUpdatesPopup()"
                class="flex items-center gap-2 text-secondary-blue text-sm font-bold hover:underline">
                See all updates
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
            </div>
          </div>

          <!-- Desktop Progress Timeline -->
          <div class="relative mt-6">
            <div *ngIf="orderDetail?.status && orderDetail.status.length > 1"
              class="absolute top-6 left-12 right-12 h-0.5 bg-gray-300">
              <div class="h-full bg-secondary-blue transition-all duration-500" [style.width]="getProgressWidth()">
              </div>
            </div>

            <div class="flex justify-between relative z-10">
              <div *ngFor="let status of orderDetail?.status" class="flex flex-col items-center gap-1">
                <div [class]="
                    'w-12 h-12 rounded-full flex items-center justify-center ' +
                    (status.isCompleted ? 'bg-blue-100' : 'bg-gray-100')
                  ">
                  <div [innerHTML]="getStatusIcon(status.stage, status.isCompleted)" class="w-6 h-6"></div>
                </div>
                <div [class]="
                    'text-sm font-bold text-center ' +
                    getStatusColor(status.stage, status.isCompleted)
                  ">
                  {{ status.stage }}
                </div>
                <div *ngIf="status.date" class="text-xs text-text-caption font-bold">
                  {{ status.date }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Order Status -->
        <div class="md:hidden">
          <div class="w-full flex justify-between items-center">
            <div class="text-[20px] text-[#0A0A5F] font-bold leading-[28px]">
              Order status
            </div>
            <button class="h-8 px-2 rounded-[12px] flex items-center gap-1" (click)="toggleOrderUpdatesPopup()">
              <div class="text-[#307FE1] text-[14px] font-bold leading-[20px] text-center">
                See all updates
              </div>
              <div class="w-6 h-6 relative overflow-hidden">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </div>
            </button>
          </div>

          <!-- Non-scrollable Full-Width Mobile Timeline -->
          <div class="relative mt-4 w-full">
            <!-- Baseline and Progress Line -->
            <div *ngIf="orderDetail?.status && orderDetail.status.length > 1"
              class="absolute top-[18px] h-0.5 bg-[#A1A9AC]" [style.left]="getTimelineInset()"
              [style.right]="getTimelineInset()">
              <div class="h-full bg-[#307FE1] transition-all duration-500" [style.width]="getProgressWidth()"></div>
            </div>

            <div class="flex justify-between items-start relative z-10 w-full">
              <div *ngFor="let status of orderDetail?.status" class="flex-1 flex flex-col items-center min-w-0">
                <div [class]="
                    'w-9 h-9 rounded-full flex items-center justify-center ' +
                    (status.isCompleted ? 'bg-blue-100' : 'bg-gray-100')
                  ">
                  <div [innerHTML]="getStatusIcon(status.stage, status.isCompleted)" [class]="
                      'w-5 h-5 flex items-center justify-center [&>svg]:w-[18px] [&>svg]:h-[18px] [&>svg]:max-w-full [&>svg]:max-h-full ' +
                      (status.isCompleted
                        ? 'text-secondary-blue'
                        : 'text-gray-400')
                    "></div>
                </div>
                <div class="text-[10px] leading-[13px] font-bold text-center mt-1 w-full px-0.5 break-words"
                  [class]="getStatusColor(status.stage, status.isCompleted)">
                  {{ status.stage }}
                </div>
                <div *ngIf="status.date"
                  class="text-[9px] leading-[11px] text-text-caption font-medium text-center mt-0.5 whitespace-nowrap">
                  {{ status.date }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }




      <!-- Store Pickup Box (Informational) -->
      <div
        *ngIf="(orderDetail?.isStorePickup || deleveryType) && (orderDetail?.invoice_status !== 'Payment Pending' || orderDetail?.isBooking || isBookingFlow || isEnquiry() || orderDetail?.isEnquiry)"
        class="w-full min-h-[110px] h-auto p-4 bg-[#F2F2F2] rounded-[8px] outline outline-1 outline-[#D4D4D4] -outline-offset-1 flex justify-between items-start max-md:h-auto max-md:min-h-[110px] max-md:flex-row max-md:gap-3 mt-6">
        <div class="w-full flex flex-col items-start gap-2 max-md:w-full">
          <div class="flex items-start gap-2 max-md:flex-col max-md:gap-1">
            <div class="flex items-center gap-1 max-md:flex-wrap">
              <div class="text-[#0A0A5F] text-[18px] font-bold leading-[24px] max-md:text-base">
                Store Pickup at :
              </div>
              <div class="text-black text-[18px] font-bold leading-[24px] max-md:text-base">
                {{ getSellerAddress()?.name || orderDetail?.sellerAddress?.name ||
                orderDetail?.items?.[0]?.seller?.seller_name }}
              </div>
              <div class="text-black text-[18px] font-bold leading-[24px] max-md:text-base"
                *ngIf="getSellerAddress()?.pincode || orderDetail?.sellerAddress?.pincode">
                {{ getSellerAddress()?.pincode || orderDetail?.sellerAddress?.pincode }}
              </div>
            </div>
          </div>
          <div class="w-full flex items-center gap-1 max-md:flex-col max-md:items-start"
            *ngIf="getSellerAddress()?.address || orderDetail?.sellerAddress?.address">
            <div class="flex-1 text-[#777777] text-[14px] font-medium leading-[20px] max-md:text-xs">
              {{ getSellerAddress()?.address || orderDetail?.sellerAddress?.address }}
            </div>
          </div>
          <div class="flex items-start gap-2 max-md:flex-col max-md:gap-1" *ngIf="orderDetail?.generated_pin">
            <div class="flex items-center gap-1 max-md:flex-wrap">
              <div class="text-[#0A0A5F] text-[14px] font-bold leading-[20px] max-md:text-xs">
                Pin :
              </div>
              <div class="text-[#0A0A5F] text-[14px] font-bold leading-[20px] max-md:text-xs">
                {{ orderDetail?.generated_pin}}
              </div>
              <div class="text-[#777777] text-[14px] font-medium leading-[20px] max-md:text-xs">
                (To be share at the counter during store pickup)
              </div>
            </div>
          </div>
        </div>
        <div class="w-6 h-6 relative overflow-hidden max-md:self-end max-md:mb-auto">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.5 4.00017V18.2298M8.5 4.00017C8.21303 4.00324 7.9265 4.04816 7.64935 4.13484L4.11774 5.23931C2.85897 5.63297 2 6.81505 2 8.15367V18.0669C2 19.0927 2.97655 19.8258 3.94113 19.5241L7.64935 18.3644C7.9265 18.2778 8.21303 18.2328 8.5 18.2298M8.5 4.00017C8.78784 3.99709 9.0761 4.03611 9.35577 4.11732L14.6442 5.65309C14.9239 5.7343 15.2122 5.77332 15.5 5.77024M8.5 18.2298C8.78784 18.2267 9.0761 18.2657 9.35577 18.3469L14.6442 19.8827C14.9239 19.9639 15.2122 20.0029 15.5 19.9998M15.5 5.77024V19.9998M15.5 5.77024C15.787 5.76717 16.0735 5.72225 16.3507 5.63557L20.0589 4.47587C21.0235 4.17421 22 4.90729 22 5.93305V15.8463C22 17.1849 21.141 18.367 19.8823 18.7607L16.3507 19.8652C16.0735 19.9518 15.787 19.9968 15.5 19.9998"
              stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>

      <!-- Refund Message Box (Informational) -->
      <div
        *ngIf="orderDetail?.invoice_status === 'Order Cancelled' || orderDetail?.invoice_status === 'Return Requested'"
        class="w-full h-[55px] p-4 bg-[#E2F3F5] rounded-[8px] outline outline-1 outline-[#D4D4D4] -outline-offset-1 flex justify-between items-start overflow-hidden max-md:h-auto max-md:min-h-[110px] max-md:flex-col max-md:gap-3 mt-6">
        <div class="w-[667px] flex flex-col items-start gap-2 max-md:w-full">
          <div class="flex items-start gap-2 max-md:flex-col max-md:gap-1">
            <div class="flex items-center gap-1 max-md:flex-wrap">
              <div
                class="text-[#1F5C6D] text-[16px] font-bold leading-[24px] max-md:text-base whitespace-nowrap max-md:whitespace-normal">
                Your refund of <b> {{ formatPrice(orderDetail?.priceBreakdown?.rounded_total ||
                  orderDetail?.priceBreakdown?.order_total || 0) }}</b> has been processed to your original payment
                method. It may reflect in 2–4 business days. </div>
            </div>
          </div>
        </div>
      </div>



      <!-- Order Items -->
      <div class="space-y-6 max-md:space-y-4">

        <div class="flex justify-between items-start text-primary-deep-blue text-xl font-bold max-md:text-[16px]">
          <!-- Left side: Title + description -->
          <div class="flex flex-col gap-1">
            <span>Items in the order ({{ orderDetail?.items?.length }})</span>
            <p class="text-gray-500 text-sm font-bold max-md:text-[12px] max-md:leading-[16px]"
              *ngIf="(orderDetail?.invoice_status === 'Payment Failed' || orderDetail?.invoice_status === 'Payment Pending' || orderDetail?.invoice_status === 'aborted') && !orderDetail?.isBooking">
              You can directly add all your available items to the cart in one go.
            </p>
          </div>

          <!-- Right side: Button -->

          <div
            *ngIf="(orderDetail?.invoice_status === 'Payment Failed' || orderDetail?.invoice_status === 'Payment Pending' || orderDetail?.invoice_status === 'aborted') && !orderDetail?.isBooking">
            <button
              class="px-6 py-1 border border-primary-deep-blue mr-5 text-base text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              (click)="moveToCart(orderDetail)">
              Move To Cart
            </button>
          </div>

        </div>


        <div class="space-y-4 max-md:space-y-3">
          <div *ngFor="let item of orderDetail?.items"
            class="flex gap-6 p-4 border-gray-200 rounded-lg max-md:gap-3 max-md:p-3">
            <!-- Product Image -->
            <div class="relative w-36 h-28 rounded-lg overflow-hidden max-md:w-28 max-md:h-24">
              <img [src]="item?.image || 'assets/default.webp'" [alt]="item?.name" class="w-full h-full object-cover" />
              <!-- Grade Badge -->
              <div *ngIf="item?.grade" [ngClass]="
                  item?.grade === 'A'
                    ? 'bg-green-100 text-green-800'
                    : item?.grade === 'B'
                    ? 'bg-yellow-100 text-yellow-800'
                    : item?.grade === 'C'
                    ? 'bg-orange-100 text-orange-800'
                    : 'bg-green-100 text-green-800'
                "
                class="absolute top-2 left-2 z-10 flex items-center px-2 py-1 rounded shadow font-bold text-xs max-md:text-[10px] max-md:px-1.5 max-md:right-0 max-md:top-0 max-md:left-12">
                <svg width="20" height="20" viewBox="0 0 20 20" class="mr-1 max-md:w-3 max-md:h-3">
                  <rect width="20" height="20" rx="4" [attr.fill]="
                      item?.grade === 'A'
                        ? '#01811D'
                        : item?.grade === 'B'
                        ? '#B8860B'
                        : item?.grade === 'C'
                        ? '#D35400'
                        : '#01811D'
                    " />
                  <text x="10" y="15" text-anchor="middle" font-size="12" font-family="Arial, sans-serif" fill="white">
                    {{ item.grade }}
                  </text>
                </svg>
                Quality
              </div>
            </div>

            <!-- Product Details -->
            <div class="flex-1 space-y-2 max-md:space-y-1">
              <!-- Name -->
              <div class="text-black text-[16px] font-bold max-md:text-sm leading-snug">
                {{ item.name }}
              </div>

              <!-- Meta Details -->
              <div
                class="flex items-center gap-1 text-sm text-text-header max-md:text-[11px] max-md:gap-0.5 max-md:flex-wrap">
                <span *ngIf="item.brand">{{ item.brand }}</span>
                <span *ngIf="item.model">•</span>
                <span *ngIf="item.model">{{ item.model }}</span>
                <span *ngIf="item.engine">•</span>
                <span *ngIf="item.year">{{ item.year }}</span>
                <!-- <span *ngIf="item.year">•</span> -->
                <!-- <span *ngIf="item.engine">•</span> -->
                <!-- <span *ngIf="item.engine">{{ item.engine }}</span> -->
              </div>

              <!-- Quantity -->
              <div class="text-sm text-text-header max-md:text-[11px]" *ngIf="item?.quantity">Qty: {{ item.quantity }}
              </div>

              <!-- Seller -->
              <div class="flex items-center gap-1 text-sm max-md:text-[11px]" *ngIf="item?.seller?.seller_name">
                <span class="text-text-caption shrink-0 whitespace-nowrap">Sold by:</span>
                <span class="text-black font-bold">{{ item?.seller?.seller_name }}</span>
              </div>

              <!-- Price -->
              <div class="text-black text-[16px] font-bold max-md:text-base">
                {{ formatPrice(item.price) }}
              </div>
              <div class="flex items-center gap-2 text-[#E30613] text-[16px] font-bold max-md:text-base"
                *ngIf="item?.available_quantity === 0">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20">
                  <circle cx="16" cy="16" r="14" fill="none" stroke="red" stroke-width="2" />
                  <rect x="15" y="8" width="2" height="12" rx="1" fill="red" />
                  <circle cx="16" cy="23" r="2" fill="red" />
                </svg>
                <span>This part is no longer available for purchase.</span>
              </div>

              <div *ngIf="item.available_quantity === 0">
                <button (click)="gotoProductList()"
                  class="text-primary-deep-blue text-sm border border-primary-deep-blue rounded-md px-3 py-1 font-bold max-md:text-[12px] max-md:leading-[16px]">
                  View Similar Parts
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Shipping Information -->
      <div class="space-y-6 pb-2 max-md:space-y-4"
        *ngIf="(orderDetail?.invoice_status !== 'Payment Failed' && orderDetail?.invoice_status !== 'aborted') || orderDetail?.isBooking || orderDetail?.billingAddress?.address || orderDetail?.shippingAddress?.address">
        <div class="text-primary-deep-blue text-xl font-bold max-md:text-[16px]">
          {{ (orderDetail?.isStorePickup || deleveryType) ? "Billing Information" : "Shipping Information" }}
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 max-md:gap-4">
          <div class="p-4 border border-input-field-stroke rounded-lg space-y-3 max-md:p-3 max-md:space-y-2"
            *ngIf="orderDetail?.billingAddress?.name || orderDetail?.billingAddress?.address">
            <div class="flex items-center gap-2 max-md:items-start max-md:gap-1">
              <div class="text-primary-deep-blue text-[16px] font-bold max-md:text-[12px] max-md:leading-[16px]">
                Billing to:
              </div>
              <div class="flex items-center gap-1 max-md:items-start max-md:gap-1">
                <div class="text-black text-[16px] font-bold max-md:text-[12px] max-md:leading-[16px]">
                  {{ orderDetail?.billingAddress?.name }}
                </div>
                <div class="text-black text-[16px] font-bold max-md:text-[12px] max-md:leading-[16px]"
                  *ngIf="orderDetail?.billingAddress?.pincode">
                  {{ orderDetail?.billingAddress?.pincode }}
                </div>
              </div>
              <div *ngIf="orderDetail?.billingAddress?.type"
                class="px-3 py-1 bg-white border border-input-field-stroke rounded-full text-text-caption text-sm font-bold max-md:text-[12px] max-md:leading-[16px] max-md:px-2 max-md:py-0.5">
                {{ orderDetail?.billingAddress?.type }}
              </div>
            </div>
            <div class="text-text-caption text-sm max-md:text-[12px] max-md:leading-[16px]"
              *ngIf="orderDetail?.billingAddress?.address">
              {{ orderDetail?.billingAddress?.address }}
            </div>
            <div *ngIf="orderDetail?.billingAddress?.gst"
              class="flex items-center gap-1 max-md:flex-col max-md:items-start max-md:gap-1">
              <div class="text-text-caption text-base max-md:text-[12px] max-md:leading-[16px]">GST:</div>
              <div class="text-text-header text-base font-bold max-md:text-[12px] max-md:leading-[16px]">
                {{ orderDetail?.billingAddress?.gst }}
              </div>
            </div>
          </div>

          <div class="p-4 border border-input-field-stroke rounded-lg space-y-3 max-md:p-3 max-md:space-y-2"
            *ngIf="orderDetail?.shippingAddress?.name || orderDetail?.shippingAddress?.address">
            <div class="flex items-center gap-2 max-md:items-start max-md:gap-1">
              <div class="text-primary-deep-blue text-[16px] font-bold max-md:text-[12px] max-md:leading-[16px]">
                Deliver to:
              </div>
              <div class="flex items-center gap-1 max-md:items-start max-md:gap-1">
                <div class="text-black text-[16px] font-bold max-md:text-[12px] max-md:leading-[16px]">
                  {{ orderDetail?.shippingAddress?.name }}
                </div>
                <div class="text-black text-[16px] font-bold max-md:text-[12px] max-md:leading-[16px]"
                  *ngIf="orderDetail?.shippingAddress?.pincode">
                  {{ orderDetail?.shippingAddress?.pincode }}
                </div>
              </div>
              <div *ngIf="orderDetail?.shippingAddress?.type"
                class="px-3 py-1 bg-white border border-input-field-stroke rounded-full text-text-caption text-sm font-bold max-md:text-[12px] max-md:leading-[16px] max-md:px-2 max-md:py-0.5">
                {{ orderDetail?.shippingAddress?.type }}
              </div>
            </div>
            <div class="text-text-caption text-sm max-md:text-[12px] max-md:leading-[16px]"
              *ngIf="orderDetail?.shippingAddress?.address">
              {{ orderDetail?.shippingAddress?.address }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sidebar -->
    <div
      class="w-80 shrink-0 space-y-6 sticky top-4 self-start h-fit max-md:w-full max-md:border-l-0 max-md:pl-0 max-md:border-t max-md:pt-4">
      <div class="border-l border-input-field-stroke pl-4 space-y-4 max-md:border-l-0 max-md:pl-0">
        <div
          class="flex justify-between items-center pb-4 border-b border-input-field-stroke max-md:items-start max-md:gap-3">
          <div class="text-text-header text-[16px] font-bold max-md:text-base">Price Details</div>
          <div class="flex items-center gap-2">
            <button *ngIf="canDownloadCreditNote()" type="button" [disabled]="isDocumentLoading"
              (click)="downloadCreditNote()"
              class="flex items-center gap-2 px-2 py-1 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors max-md:w-28 max-md:justify-center max-md:py-2 disabled:opacity-50 disabled:cursor-not-allowed">
              Credit Note
            </button>
            <button *ngIf="canDownloadDocument() && getDocumentButtonLabel() !== 'Enquiry'" type="button"
              [disabled]="isDocumentLoading" (click)="downloadInvoice()"
              class="flex items-center gap-2 px-2 py-1 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors max-md:w-28 max-md:justify-center max-md:py-2 disabled:opacity-50 disabled:cursor-not-allowed">
              <svg *ngIf="!isDocumentLoading" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                </path>
              </svg>
              <span *ngIf="isDocumentLoading"
                class="inline-block animate-spin rounded-full h-4 w-4 border-2 border-current border-t-transparent"></span>
              {{ getDocumentButtonLabel() }}
            </button>
          </div>
        </div>

        <div class="space-y-2 max-md:space-y-3">
          <div class="flex justify-between items-center"
            *ngIf="(orderDetail?.priceBreakdown?.base_price > 0 || orderDetail?.priceBreakdown?.order_total > 0)">
            <div class="text-black text-sm max-md:text-base">Part Sub Total</div>
            <div class="text-black text-sm font-bold max-md:text-base">
              {{ formatPrice((orderDetail?.priceBreakdown?.base_price > 0 ? orderDetail?.priceBreakdown?.base_price :
              orderDetail?.priceBreakdown?.order_total) || 0) }}
            </div>
          </div>

          <div class="flex justify-between items-center" *ngIf="orderDetail?.priceBreakdown?.scrap_booking_amount > 0">
            <div class="text-black text-sm max-md:text-base">
              {{ document_type === 'Enquiry' ? 'Enquiry Amount' : 'Scrap Booking Amount' }}
              <!-- <span *ngIf="getBookingPercentage()"
                class="text-xs font-bold text-blue-600 ml-1">
                ({{ getBookingPercentage() }}%)
              </span> -->
            </div>
            <div class="text-black text-sm font-bold max-md:text-base">
              {{ formatPrice(orderDetail?.priceBreakdown?.scrap_booking_amount || 0) }}
            </div>
          </div>

          <div class="pb-4 border-b border-input-field-stroke space-y-2 max-md:space-y-3">
            <div class="flex justify-between items-center">
              <div class="text-black text-sm max-md:text-base">Discount on Base Price</div>
              <div class="text-semantic-green text-sm max-md:text-base">
                - {{ formatPrice(orderDetail?.priceBreakdown?.discount || 0) }}
              </div>
            </div>
            <div class="flex justify-between items-center">
              <div class="text-black text-sm max-md:text-base">Platform Charges</div>
              <div class="text-black text-sm max-md:text-base">
                +
                {{
                formatPrice(orderDetail?.priceBreakdown?.platform_charges || 0)
                }}
              </div>
            </div>
            <div class="flex justify-between items-center">
              <div class="text-black text-sm max-md:text-base">Delivery Charges</div>
              <div class="text-semantic-green text-sm max-md:text-base"> + {{
                formatPrice(orderDetail?.priceBreakdown?.delivery_charges || 0) }}</div>
            </div>
            <div class="flex justify-between items-center">
              <div class="text-black text-sm max-md:text-base">GST</div>
              <div class="text-black text-sm max-md:text-base">
                + {{ formatPrice(orderDetail?.priceBreakdown?.gst_amount || 0) }}
              </div>
            </div>
            <div class="flex justify-between items-center"
              *ngIf="orderDetail?.priceBreakdown?.roundoff_amount && orderDetail?.priceBreakdown?.roundoff_amount !== 0">
              <div class="text-black text-sm max-md:text-base">Round Off</div>
              <div class="text-black text-sm max-md:text-base">+ {{
                formatPrice(orderDetail?.priceBreakdown?.roundoff_amount) }}</div>
            </div>
            <div class="flex justify-between items-center" *ngIf="orderDetail?.priceBreakdown?.tcs_amount > 0">
              <div class="text-black text-sm max-md:text-base">TCS</div>
              <div class="text-black text-sm max-md:text-base">+ {{ formatPrice(orderDetail?.priceBreakdown?.tcs_amount)
                }}</div>
            </div>
          </div>

          <div class="flex justify-between items-center">
            <div class="text-black text-base font-bold max-md:text-[16px]">Total Amount</div>
            <div class="text-black text-base font-bold max-md:text-[16px]">
              {{ formatPrice(orderDetail?.priceBreakdown?.order_total || 0) }}
            </div>
          </div>

          <div class="flex justify-between items-center"
            *ngIf="orderDetail?.isBooking && orderDetail?.priceBreakdown?.pending_amount > 0">
            <div class="text-black text-sm max-md:text-base">Balance after booking</div>
            <div class="text-black text-sm font-bold max-md:text-base">{{
              formatPrice(orderDetail?.priceBreakdown?.pending_amount) }}</div>
          </div>
        </div>

        <div class="space-y-6 max-md:space-y-4">
          <div class="text-primary-deep-blue text-[16px] font-bold max-md:text-base">Need Help</div>
          <!-- <div *ngIf="isOrderDelivered()"
            class="inline-flex items-center gap-1 max-md:flex-col max-md:items-start max-md:gap-2">
            <div class="text-sm font-bold text-black whitespace-nowrap max-md:text-xs">
              Return policy valid till {{ getReturnPolicyValidDate() }}.
            </div>
            <div (click)="knowMore()"
              class="text-sm font-bold text-secondary-blue cursor-pointer hover:underline whitespace-nowrap max-md:text-xs">

              Know More
            </div>
        </div> -->

          <!-- Action Buttons -->
          <div class="flex flex-col items-start gap-4 w-full max-md:gap-3 max-md:pb-3">
            <!-- Return/Refund Button -->
            <!-- <button *ngIf="isOrderDelivered()" (click)="returnRefund()"
              class="w-full flex items-center justify-center gap-2 p-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors max-md:py-3 max-md:text-base">
              <svg class="w-5 h-5 max-md:w-6 max-md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                </path>
              </svg>
              Return/Refund
            </button> -->
            <button (click)="contactSupport()"
              class="w-full flex items-center justify-center gap-2 p-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors max-md:py-3 max-md:text-base">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M4.16667 9.16667V8.33333C4.16667 5.11167 6.77834 2.5 10 2.5C13.2217 2.5 15.8333 5.11167 15.8333 8.33333V9.16667M4.16667 9.16667H5.41667C5.64679 9.16667 5.83333 9.35321 5.83333 9.58333V13.75C5.83333 13.9801 5.64679 14.1667 5.41667 14.1667H4.16667C3.24619 14.1667 2.5 13.4205 2.5 12.5V10.8333C2.5 9.91286 3.24619 9.16667 4.16667 9.16667ZM15.8333 9.16667H14.5833C14.3532 9.16667 14.1667 9.35321 14.1667 9.58333V13.75C14.1667 13.9801 14.3532 14.1667 14.5833 14.1667H15M15.8333 9.16667C16.7538 9.16667 17.5 9.91286 17.5 10.8333V12.5C17.5 13.4205 16.7538 14.1667 15.8333 14.1667H15M15 14.1667C15 15.8333 13.3333 16.6667 11.6667 16.6667M11.6667 16.6667V16.25C11.6667 16.0199 11.4801 15.8333 11.25 15.8333H10C9.53976 15.8333 9.16667 16.2064 9.16667 16.6667C9.16667 17.1269 9.53976 17.5 10 17.5H11.25C11.4801 17.5 11.6667 17.3135 11.6667 17.0833V16.6667Z"
                  stroke="#0A0A5F" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              Customer Support
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Product Cancellation Side Popup -->
  <div *ngIf="showCancelPopup" class="fixed inset-0 z-50 flex items-end justify-end md:items-end md:justify-end">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black bg-opacity-50 popup-backdrop" (click)="closeCancelPopup()"></div>

    <!-- Popup Content -->
    <div
      class="relative w-full h-[90vh] md:h-screen md:w-96 bg-white shadow-2xl flex flex-col rounded-t-3xl md:rounded-none cancellation-popup">
      <!-- Header -->
      <div class="p-4 md:p-6 border-b border-gray-200 flex justify-between items-center">
        <h2 class="text-xl md:text-2xl font-bold text-primary-deep-blue">
          Cancel Products
        </h2>
        <button (click)="closeCancelPopup()" class="text-gray-500 hover:text-gray-700">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Product Selection Step -->
      <div *ngIf="cancelStep === 'select'" class="flex-1 overflow-y-auto">
        <div class="p-4 md:p-6">
          <h3 class="text-[16px] font-bold text-gray-800 mb-4">
            Select products to cancel:
          </h3>

          <div class="space-y-3">
            <div *ngFor="let item of orderDetail?.items; let i = index"
              class="flex items-start gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50">
              <input type="checkbox" [id]="'product-' + i" [(ngModel)]="item.selectedForCancel"
                (change)="updateProceedButton()"
                class="mt-1 w-4 h-4 text-primary-deep-blue border-gray-300 rounded focus:ring-primary-deep-blue" />

              <div class="flex-1 flex gap-3">
                <img [src]="item.image || 'assets/default.webp'" [alt]="item.name"
                  class="w-16 h-12 object-cover rounded" />
                <div class="flex-1">
                  <h4 class="font-bold text-gray-800">{{ item.name }}</h4>
                  <p class="text-gray-600 text-sm">
                    {{ item.brand }} • {{ item.model }}
                  </p>
                  <p class="font-bold text-gray-800">
                    {{ formatPrice(item.price) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cancellation Details Step -->
      <div *ngIf="cancelStep === 'details'" class="flex-1 overflow-y-auto">
        <div class="p-4 md:p-6">
          <div class="mb-6">
            <!-- <button
              (click)="backToSelection()"
              class="flex items-center gap-2 text-primary-deep-blue hover:underline mb-4"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
              Back to selection
            </button> -->

            <h3 class="text-[16px] font-bold text-gray-800 mb-4">
              Cancel Product {{ currentProductIndex + 1 }} of
              {{ selectedProducts.length }}:
            </h3>

            <!-- Current Product Info -->
            <div *ngIf="currentProduct" class="flex gap-3 p-3 bg-gray-50 rounded-lg mb-6">
              <img [src]="currentProduct.image || 'assets/default.webp'" [alt]="currentProduct.name"
                class="w-16 h-12 object-cover rounded" />
              <div>
                <h4 class="font-bold text-gray-800">
                  {{ currentProduct.name }}
                </h4>
                <p class="text-gray-600 text-sm">
                  {{ currentProduct.brand }} • {{ currentProduct.model }}
                </p>
                <p class="font-bold text-gray-800">
                  {{ formatPrice(currentProduct.price) }}
                </p>
              </div>
            </div>


            <!-- Cancellation Reason for Current Product -->
            <div *ngIf="currentProduct" class="mb-6">
              <h4 class="font-bold text-gray-800 mb-3">
                Select cancellation reason:
              </h4>
              <div class="space-y-2">
                <div *ngFor="let reason of cancellationReasons"
                  class="flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer"
                  [class.border-primary-deep-blue]="
                    currentProduct.selectedReason === reason.value
                  " [class.bg-blue-50]="
                    currentProduct.selectedReason === reason.value
                  " (click)="selectReason(reason.value)">
                  <input type="radio" [name]="'reason-' + currentProductIndex" [value]="reason.value"
                    [checked]="currentProduct.selectedReason === reason.value"
                    class="w-4 h-4 text-primary-deep-blue border-gray-300 focus:ring-primary-deep-blue" readonly />
                  <span class="flex-1">{{ reason.label }}</span>
                </div>
              </div>


            </div>
          </div>

          <!-- Optional Comment -->
          <div *ngIf="currentProduct" class="mb-6">
            <label class="block font-bold text-gray-800 mb-2">
              Comment <span class="text-gray-500 font-normal">(Optional)</span>
            </label>
            <textarea [(ngModel)]="currentProduct.cancellationComment" placeholder="Anything you want to add..."
              class="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-deep-blue focus:border-transparent resize-none"
              rows="3"></textarea>
          </div>

          <!-- Refund Details -->
          <div *ngIf="currentProduct && currentProduct.selectedReason" class="bg-gray-50 p-4 rounded-lg">
            <div class="flex justify-between items-center mb-2">
              <span class="font-bold text-gray-800">Refund Amount:</span>
              <span class="font-bold text-gray-800">{{
                formatPrice(currentProduct.refundAmount || 0)
                }}</span>
            </div>
            <p class="text-sm text-gray-600">
              Platform fee will be charged for this product
            </p>
            <!-- <p
              *ngIf="getCancellationReasonMessage()"
              class="text-sm text-blue-600 mt-1"
            >
              {{ getCancellationReasonMessage() }}
            </p> -->
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="p-4 md:p-6 border-t border-gray-200 flex gap-3">
        <button *ngIf="cancelStep === 'select'" (click)="closeCancelPopup()"
          class="flex-1 px-4 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors">
          Cancel
        </button>

        <button *ngIf="cancelStep === 'select'" (click)="proceedToDetails()" [disabled]="!canProceed"
          class="flex-1 px-4 py-2 bg-primary-deep-blue text-white rounded-lg font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          Proceed
        </button>

        <button *ngIf="cancelStep === 'details'" (click)="backToSelection()"
          class="flex-1 px-4 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors">
          Back
        </button>

        <button *ngIf="cancelStep === 'details'" (click)="proceedToNextProduct()"
          [disabled]="!currentProduct?.selectedReason"
          class="flex-1 px-4 py-2 bg-primary-deep-blue text-white rounded-lg font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          {{ isLastProduct ? "Proceed" : "Proceed" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Product Return Side Popup -->
  <div *ngIf="showReturnPopup" class="fixed inset-0 z-50 flex items-end justify-end md:items-end md:justify-end">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black bg-opacity-50 popup-backdrop" (click)="closeReturnPopup()"></div>

    <!-- Popup Content -->
    <div
      class="relative w-full h-[90vh] md:w-96 bg-white shadow-2xl flex flex-col rounded-t-3xl md:rounded-none return-popup">
      <!-- Header -->
      <div class="p-4 md:p-6 border-b border-gray-200 flex justify-between items-center">
        <h2 class="text-xl md:text-2xl font-bold text-primary-deep-blue">
          Return Products
        </h2>
        <button (click)="closeReturnPopup()" class="text-gray-500 hover:text-gray-700">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Product Selection Step -->
      <div *ngIf="returnStep === 'select'" class="flex-1 overflow-y-auto">
        <div class="p-4 md:p-6">
          <h3 class="text-[16px] font-bold text-gray-800 mb-4">
            Select products to return:
          </h3>

          <div class="space-y-3">
            <div *ngFor="let item of orderDetail?.items; let i = index"
              class="flex items-start gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50">
              <input type="checkbox" [id]="'return-product-' + i" [(ngModel)]="item.selectedForReturn"
                (change)="updateProceedReturnButton()"
                class="mt-1 w-4 h-4 text-primary-deep-blue border-gray-300 rounded focus:ring-primary-deep-blue" />

              <div class="flex-1 flex gap-3">
                <img [src]="item?.image || 'assets/default.webp'" [alt]="item?.name"
                  class="w-16 h-12 object-cover rounded" />
                <div class="flex-1">
                  <h4 class="font-bold text-gray-800">{{ item?.name }}</h4>
                  <p class="text-gray-600 text-sm">
                    {{ item?.brand }} • {{ item?.model }}
                  </p>
                  <p class="font-bold text-gray-800">
                    {{ formatPrice(item?.price) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Return Details Step -->
      <div *ngIf="returnStep === 'details'" class="flex-1 overflow-y-auto">
        <div class="p-4 md:p-6">
          <div class="mb-6">
            <!-- <button
              (click)="backToReturnSelection()"
              class="flex items-center gap-2 text-primary-deep-blue hover:underline mb-4"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
              Back to selection
            </button> -->

            <h3 class="text-[16px] font-bold text-gray-800 mb-4">
              Return Product {{ currentReturnProductIndex + 1 }} of
              {{ selectedReturnProducts.length }}:
            </h3>

            <!-- Current Product Info -->
            <div *ngIf="currentReturnProduct" class="flex gap-3 p-3 bg-gray-50 rounded-lg mb-6">
              <img [src]="currentReturnProduct.image || 'assets/default.webp'" [alt]="currentReturnProduct.name"
                class="w-16 h-12 object-cover rounded" />
              <div>
                <h4 class="font-bold text-gray-800">
                  {{ currentReturnProduct.name }}
                </h4>
                <p class="text-gray-600 text-sm">
                  {{ currentReturnProduct.brand }} •
                  {{ currentReturnProduct.model }}
                </p>
                <p class="font-bold text-gray-800">
                  {{ formatPrice(currentReturnProduct.price) }}
                </p>
              </div>
            </div>

            <!-- Return Note -->
            <div class="p-2 bg-blue-50 border border-blue-200 rounded-lg mb-6">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <p class="text-blue-800 text-sm font-medium">
                  Note: Keep the original box—required for return pickup.
                </p>
              </div>
            </div>
          </div>

          <!-- Return Reason -->
          <div *ngIf="currentReturnProduct" class="mb-6">
            <h4 class="text-[16px] font-bold text-gray-800 mb-4">
              Select the reason:
            </h4>
            <div class="space-y-2">
              <div *ngFor="let reason of returnReasons"
                class="flex items-center gap-3 p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer"
                [class.border-primary-deep-blue]="
                  currentReturnProduct.returnReason === reason?.value
                " (click)="selectReturnReason(reason?.value)">
                <input type="radio" [name]="'return-reason-' + currentReturnProductIndex" [value]="reason.value"
                  [(ngModel)]="currentReturnProduct.returnReason" (change)="updateReturnRefundAmount()"
                  class="w-4 h-4 text-primary-deep-blue border-gray-300 focus:ring-primary-deep-blue" />
                <span class="flex-1">{{ reason?.label }}</span>
              </div>
            </div>
          </div>

          <!-- Upload Proof -->
          <div *ngIf="currentReturnProduct" class="mb-6">
            <h4 class="text-[16px] font-bold text-gray-800 mb-4">Upload proof:</h4>

            <!-- Show upload area if no files -->
            <div *ngIf="!currentReturnProduct.uploadedFileUrls?.length">
              <div
                class="border-2 border-dashed border-blue-300 rounded-lg p-8 text-center bg-blue-50 hover:bg-blue-100 transition-colors">
                <input type="file" [id]="'file-upload-' + currentReturnProductIndex"
                  (change)="onFileSelected($event, currentReturnProduct)" accept="image/jpeg,image/jpg,image/png"
                  class="hidden" />
                <label [for]="'file-upload-' + currentReturnProductIndex" class="cursor-pointer">
                  <div class="flex flex-col items-center gap-2">
                    <svg class="w-12 h-12 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12">
                      </path>
                    </svg>
                    <span class="text-primary-deep-blue font-bold">Upload Photo/Video</span>
                  </div>
                </label>
              </div>

              <!-- File Requirements -->
              <div class="flex items-center gap-4 mt-2 text-sm text-gray-600">
                <span>File Supported: JPG/PNG format</span>
                <span>File Size: Max 50MB</span>
              </div>
            </div>

            <!-- Show uploaded files -->
            <div *ngIf="currentReturnProduct.uploadedFileUrls?.length" class="mt-4 flex gap-2 overflow-x-auto">
              <!-- Add More Upload Box -->
              <div
                class="relative w-20 h-20 aspect-square border-dashed border-2 border-[color:var(--Primary-Deep-Blue,#0A0A5F)] rounded-lg cursor-pointer flex flex-col items-center justify-center hover:bg-blue-50 transition-colors"
                (click)="fileInput.click()">
                <input type="file" accept=".jpg,.jpeg,.png" #fileInput class="hidden"
                  (change)="onFileSelected($event, currentReturnProduct)" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 56 40" fill="none"
                  class="sm:w-8 sm:h-6">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14.0848 11.0012C15.3425 11.0012 16.5596 11.1665 17.7191 11.4756C19.4297 5.2683 25.1149 0.708984 31.8631 0.708984C38.6261 0.708984 44.3188 5.28479 46.017 11.5111C49.3135 11.8944 51.8746 14.695 51.8746 18.0944C51.8746 18.9257 51.7212 19.7186 51.4433 20.4518C54.1865 22.306 56 25.4445 56 28.9878C56 34.6513 51.3667 39.2845 45.7032 39.2845H33.0464C32.7077 39.2845 32.4331 39.01 32.4331 38.6712V27.8544C32.4331 27.5157 32.7077 27.2411 33.0464 27.2411H35.2103C35.7461 27.2411 36.0243 26.6023 35.6594 26.21L28.4499 18.4598C28.2074 18.1991 27.7944 18.1991 27.5518 18.4598L20.3424 26.21C19.9775 26.6023 20.2557 27.2411 20.7915 27.2411H22.9553C23.2941 27.2411 23.5687 27.5157 23.5687 27.8544V38.6712C23.5687 39.01 23.2941 39.2845 22.9553 39.2845H13.9716C12.8864 39.2845 11.8394 39.1121 10.8524 38.7982C4.63291 37.3368 0 31.7526 0 25.0878C0 17.3111 6.30539 11.0032 14.0846 11.0032L14.0848 11.0012Z"
                    fill="#307FE1" />
                </svg>
                <span class="font-semibold text-xs sm:text-sm mt-1 text-[color:var(--Primary-Deep-Blue,#0A0A5F)]">Add
                  More</span>
              </div>

              <!-- Uploaded Files -->
              <div *ngFor="let fileUrl of currentReturnProduct.uploadedFileUrls; let i = index"
                class="relative w-20 h-20 border-2 border-primary-deep-blue rounded-lg overflow-hidden">
                <img [src]="fileUrl || 'assets/default.webp'" alt="Uploaded file" class="w-full h-full object-cover" />
                <button (click)="removeFile(currentReturnProduct, i)"
                  class="absolute top-0 right-0 bg-red-500 text-white w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600">
                  ×
                </button>
              </div>
            </div>
          </div>


          <!-- Optional Comment -->
          <div *ngIf="currentReturnProduct" class="mb-6">
            <label class="block font-bold text-gray-800 mb-2">
              Describe the issue
              <span class="text-gray-500 font-normal">(Optional)</span>
            </label>
            <textarea [(ngModel)]="currentReturnComment" placeholder="Write the issue in detail..."
              class="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-deep-blue focus:border-transparent resize-none"
              rows="3"></textarea>
          </div>

          <!-- Refund Details -->
          <div *ngIf="currentReturnProduct" class="bg-gray-50 p-4 rounded-lg">
            <div class="flex justify-between items-center mb-2">
              <span class="font-bold text-gray-800">Refund Amount:</span>
              <span class="font-bold text-gray-800">{{
                formatPrice(currentReturnProduct.returnRefundAmount || 0)
                }}</span>
            </div>
            <p class="text-sm text-gray-600">
              Platform fee will be charged for this product
            </p>
            <!-- <p
              *ngIf="getSelectedReturnReasonMessage()"
              class="text-sm text-blue-600 mt-1"
            >
              {{ getSelectedReturnReasonMessage() }}
            </p> -->
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="p-4 md:p-6 border-t border-gray-200 flex gap-3">
        <button *ngIf="returnStep === 'select'" (click)="closeReturnPopup()"
          class="flex-1 px-4 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors">
          Cancel
        </button>

        <button *ngIf="returnStep === 'select'" (click)="proceedToReturnDetails()" [disabled]="!canProceedReturn"
          class="flex-1 px-4 py-2 bg-primary-deep-blue text-white rounded-lg font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          Proceed
        </button>

        <button *ngIf="returnStep === 'details'" (click)="backToReturnSelection()"
          class="flex-1 px-4 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold hover:bg-primary-deep-blue hover:text-white transition-colors">
          Back
        </button>

        <button *ngIf="returnStep === 'details'" (click)="proceedToNextReturnProduct()"
          [disabled]="!canProceedToNextReturn()"
          class="flex-1 px-4 py-2 bg-primary-deep-blue text-white rounded-lg font-bold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          {{ isLastReturnProduct ? "Submit" : "Next Product" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Order Updates Popup -->
  <div *ngIf="showOrderUpdatesPopup" class="fixed inset-0 z-50 flex items-end justify-end md:items-end md:justify-end"
    (click)="toggleOrderUpdatesPopup()">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black bg-opacity-50 popup-backdrop" (click)="toggleOrderUpdatesPopup()"></div>

    <!-- Popup Content -->
    <div
      class="relative w-full h-[90vh] md:h-screen md:w-[484px] bg-white shadow-md overflow-hidden order-updates-popup flex flex-col rounded-t-3xl md:rounded-none"
      (click)="$event.stopPropagation()">
      <!-- Header -->
      <div
        class="w-full px-4 md:px-6 py-3 md:py-4 border-b border-gray-300 flex justify-between items-center flex-shrink-0">
        <h2 class="text-xl md:text-2xl font-bold text-primary-deep-blue">Order Updates</h2>
        <button (click)="toggleOrderUpdatesPopup()" class="hover:bg-gray-100 p-1 rounded close-button">
          <svg width="20" height="20" class="md:w-6 md:h-6" fill="none" stroke="#0A0A5F" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Timeline -->
      <div #popupTimelineContainer
        class="px-4 md:px-6 py-4 md:py-6 relative flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        <!-- Timeline line - only show if there are status items -->
        <div *ngIf="popupStatusList && popupStatusList.length > 0"
          class="absolute left-6 md:left-8 top-7 w-0.5 bg-gray-300" [style.height]="getPopupTimelineLineHeight()"
          style="z-index:0"></div>
        <!-- Blue progress line overlay -->
        <div *ngIf="popupStatusList && popupStatusList.length > 0"
          class="absolute left-6 md:left-8 top-7 w-0.5 bg-blue-500 transition-all duration-500"
          [style.height]="getPopupTimelineProgressHeight()" style="z-index:1"></div>

        <!-- Dynamic Timeline Items from API -->
        <div #popupTimelineItems *ngIf="popupStatusList && popupStatusList.length > 0; else noStatusData"
          class="space-y-4 md:space-y-5">
          <div *ngFor="let status of popupStatusList; let i = index; trackBy: trackByStatus"
            class="relative flex items-start gap-2 md:gap-3 timeline-item">
            <div
              class="relative z-10 ml-[-3px] md:ml-[-7px] w-6 h-6 md:w-8 md:h-8 flex items-center justify-center rounded-full flex-shrink-0"
              [class]="status.isCompleted ? 'bg-blue-100 border border-blue-500' : 'bg-gray-100'">
              <div [innerHTML]="getStatusIconForTimeline(status.icon || 'order-placed', status.isCompleted)"></div>
            </div>
            <div class="min-w-0 flex-1">
              <p class="font-bold text-sm md:text-base"
                [class]="status.isCompleted ? 'text-blue-600' : 'text-gray-400'">
                {{ status.stage || 'Order Placed' }}
              </p>
              <p *ngIf="status.date" class="text-xs md:text-sm font-semibold"
                [class]="status.isCompleted ? 'text-gray-600' : 'text-gray-400'">
                {{ status.date }}
              </p>
              <p class="text-xs mt-1" [class]="status.isCompleted ? 'text-gray-700' : 'text-gray-400'">
                {{ status.description || 'Status update pending' }}
              </p>
              <!-- <p 
                *ngIf="status.timestamp && status.date" 
                class="text-xs"
                [class]="status.isCompleted ? 'text-gray-500' : 'text-gray-400'"
              >
                {{ formatTimestampForDisplay(status.timestamp) }}
              </p> -->
            </div>
          </div>
        </div>

        <!-- No Status Data Template -->
        <ng-template #noStatusData>
          <div class="flex flex-col items-center justify-center py-8 text-center">
            <div class="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <svg width="24" height="24" fill="none" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M9 12l2 2 4-4" />
                <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3" />
                <path d="M3 12c1 0 3-1 3-3s-2-3-3-3-3 1-3 3 2 3 3 3" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-600 mb-2">Order Status Unavailable</h3>
            <p class="text-sm text-gray-500 max-w-sm">
              We're currently unable to load your order status. Please try refreshing the page or contact support if the
              issue persists.
            </p>
            <button (click)="seeAllUpdatesStatus()"
              class="mt-4 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors">
              Refresh Status
            </button>
          </div>
        </ng-template>
      </div>

      <!-- Footer -->
      <div class="w-full px-4 md:px-6 py-3 border-t border-gray-300 flex justify-between items-center flex-shrink-0">
        <button (click)="toggleOrderUpdatesPopup()"
          class="px-3 md:px-4 py-2 text-sm md:text-base border border-primary-deep-blue text-primary-deep-blue font-bold rounded-lg hover:bg-primary-deep-blue hover:text-white transition-colors popup-button">
          Back
        </button>
        <!-- <button
          class="px-3 md:px-4 py-2 text-sm md:text-base bg-primary-deep-blue text-white font-bold rounded-lg hover:bg-blue-700 transition-colors popup-button">
          Proceed
        </button> -->
      </div>
    </div>
  </div>
</div>

<!-- Rating Popup -->
<div *ngIf="showRatingPopup" class="fixed inset-0 z-50 flex items-end justify-end md:items-end md:justify-end"
  (click)="toggleRatingPopup()">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black bg-opacity-50 popup-backdrop" (click)="toggleRatingPopup()"></div>

  <!-- Popup Content -->
  <div
    class="relative w-full h-[90vh] md:w-96 bg-white shadow-2xl overflow-hidden rating-popup flex flex-col rounded-t-3xl md:rounded-none"
    (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="p-4 md:p-6 border-b border-gray-200 flex justify-between items-center">
      <h2 class="text-xl md:text-2xl font-bold text-primary-deep-blue">Rate the order</h2>
      <button (click)="toggleRatingPopup()" class="text-gray-500 hover:text-gray-700">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="p-4 md:p-6 flex flex-col gap-6 flex-1 overflow-y-auto">
      <!-- Rating Section -->
      <div class="flex items-center gap-4">
        <!-- Emoji 1 -->
        <button (click)="selectRating(1)" class="
                size-14 flex justify-center items-center rounded-full">

          <svg width="47" height="47" viewBox="0 0 47 47" [attr.fill]="selectedRating === 1 ? '#E53935' : '#D4D4D4'"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M46.6667 23.3333C46.6667 36.22 36.22 46.6667 23.3333 46.6667C10.4467 46.6667 0 36.22 0 23.3333C0 10.4467 10.4467 0 23.3333 0C36.22 0 46.6667 10.4467 46.6667 23.3333Z"
              [attr.fill]="selectedRating === 1 ? '#E53935' : '#D4D4D4'" />
            <path
              d="M30.334 32.6666C30.334 32.6666 28.0007 30.3332 23.334 30.3332C18.6673 30.3332 16.334 32.6666 16.334 32.6666M11.6445 23.0725C13.5705 23.9175 17.0174 23.3098 18.5382 21.8569M28.1298 21.8568C29.6506 23.3096 33.0974 23.9174 35.0234 23.0723"
              stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" stroke="black" />
          </svg>
        </button>

        <!-- Emoji 2 -->
        <button (click)="selectRating(2)" [class]="
                'size-14 flex justify-center items-center rounded-full ' +
                (selectedRating === 2
                  ? 'border-2'
                  : '')
              ">

          <svg width="56" height="56" viewBox="0 0 56 56" [attr.fill]="selectedRating === 2 ? '#FFEB3B' : '#D4D4D4'"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M51.3327 28C51.3327 40.8866 40.886 51.3333 27.9993 51.3333C15.1127 51.3333 4.66602 40.8866 4.66602 28C4.66602 15.1133 15.1127 4.66663 27.9993 4.66663C40.886 4.66663 51.3327 15.1133 51.3327 28Z"
              [attr.fill]="selectedRating === 2 ? '#FFEB3B' : '#D4D4D4'" />
            <path
              d="M20.2217 22.1667C21.5102 22.1667 22.5555 23.2112 22.5557 24.4998C22.5557 25.7884 21.5103 26.8337 20.2217 26.8337C18.9332 26.8336 17.8887 25.7883 17.8887 24.4998C17.8888 23.2113 18.9333 22.1669 20.2217 22.1667ZM35.7773 22.1667C37.0659 22.1667 38.1112 23.2112 38.1113 24.4998C38.1113 25.7884 37.066 26.8337 35.7773 26.8337C34.4888 26.8336 33.4443 25.7883 33.4443 24.4998C33.4445 23.2113 34.4889 22.1669 35.7773 22.1667Z"
              fill="black" />
            <path d="M35 37.3335H21" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"
              stroke="black" />
          </svg>


        </button>

        <!-- Emoji 3 -->
        <button (click)="selectRating(3)" [class]="
                'size-14 flex justify-center items-center rounded-full ' +
                (selectedRating === 3
                  ? 'border-2'
                  : '')
              ">

          <svg width="56" height="56" viewBox="0 0 56 56" [attr.fill]="selectedRating === 3 ? '#36B548' : '#D4D4D4'"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M51.3327 28C51.3327 40.8866 40.886 51.3333 27.9993 51.3333C15.1127 51.3333 4.66602 40.8866 4.66602 28C4.66602 15.1133 15.1127 4.66663 27.9993 4.66663C40.886 4.66663 51.3327 15.1133 51.3327 28Z"
              [attr.fill]="selectedRating === 3 ? '#36B548' : '#D4D4D4'" />
            <path
              d="M16.3316 23.3335C17.4983 17.5002 22.1649 17.5002 23.3316 23.3335M32.6649 23.3335C33.8316 17.5002 38.4982 17.5002 39.6649 23.3335M27.9983 42.0002C21.9026 42.0002 16.7168 38.1044 14.7949 32.6668C14.7949 32.6668 23.3316 33.8335 27.9983 33.8335C32.665 33.8335 41.2017 32.6668 41.2017 32.6668C39.2798 38.1044 34.094 42.0002 27.9983 42.0002Z"
              stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" stroke="black" />
          </svg>


        </button>

        <span class="text-[16px] font-bold text-primary-deep-blue">
          {{
          selectedRating === 1
          ? "Poor"
          : selectedRating === 2
          ? "Good"
          : selectedRating === 3
          ? "Excellent"
          : ""
          }}
        </span>
      </div>

      <!-- Chips Section -->
      <div class="flex flex-col gap-2">
        <p class="text-base font-bold text-gray-800">
          {{ getCurrentFeedbackData().question }}
        </p>

        <div class="flex flex-wrap gap-2">
          <button *ngFor="let chip of getCurrentFeedbackData().chips" (click)="toggleChip(chip)" [ngClass]="
        isChipSelected(chip)
          ? 'border-blue-500 bg-blue-50 text-blue-600'
          : 'border-gray-300 bg-white text-gray-800'
      " class="rounded-lg border px-3 py-2 text-sm font-medium transition-colors duration-200">
            {{ chip }}
          </button>
        </div>
      </div>

      <!-- Review Section -->
      <div class="flex flex-col gap-1">
        <p class="text-base font-bold text-gray-800">Submit your Review</p>
        <textarea [(ngModel)]="reviewComment" rows="4"
          class="w-full p-3 border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-deep-blue"
          placeholder="Any other comment which you want to highlight."></textarea>
      </div>
    </div>

    <!-- Footer -->
    <div class="p-4 md:p-6 border-t border-gray-200 flex gap-3 flex-shrink-0">
      <button (click)="toggleRatingPopup()"
        class="flex-1 px-4 py-2 border border-primary-deep-blue text-primary-deep-blue rounded-lg font-bold transition-colors">
        Cancel
      </button>
      <button (click)="submitRating()"
        class="flex-1 px-4 py-2 bg-primary-deep-blue text-white rounded-lg font-bold hover:bg-primary-deep-blue/90 transition-colors">
        Submit
      </button>
    </div>
  </div>
</div>